import React from "react";

function DeleteAccount() {
  return (
    <div className="content">
      <h1>Delete Account</h1>
      <p>
        To delete your account and all associated data, please send an email to{" "}
        <a href="mailto:support@loren-it.com?subject=Account%20Deletion%20Request">
          support@loren-it.com
        </a>{" "}
        with the subject "Account Deletion Request".
      </p>
      <p>
        Please include your registered email address in the body of the email.
        We will process your request within 30 days.
      </p>
    </div>
  );
}

export default DeleteAccount;
